var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wk-detail-table" },
    [
      _vm.showType === "default"
        ? _vm._l(_vm.fieldList, function (children, index) {
            return _c(
              "div",
              { key: index, staticClass: "detail-item" },
              [
                _c(
                  "flexbox",
                  { staticClass: "detail-item__head" },
                  [
                    _c("div", { staticClass: "detail-item__head-title" }, [
                      _vm._v(
                        _vm._s(_vm.title) + "（" + _vm._s(index + 1) + "）"
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.fieldList.length > 1
                      ? _c("el-button", {
                          attrs: { icon: "wk wk-icon-bin", type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.deleteClick(index)
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("wk-form-items", {
                  attrs: {
                    "field-from": _vm.fieldForm[index],
                    "field-list": children,
                    "prop-prefix": `${_vm.propPrefix || ""}[${index}].`,
                    disabled: _vm.disabled,
                  },
                  on: { change: _vm.formChange },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "add-btn" },
                  [
                    _c(
                      "el-button",
                      { attrs: { type: "text" }, on: { click: _vm.addClick } },
                      [
                        _c("i", { staticClass: "wk wk-l-plus" }),
                        _vm._v(
                          "\n          " + _vm._s(_vm.btnName) + "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          })
        : _vm.showType === "table"
        ? _c(
            "div",
            { staticClass: "detail-item" },
            [
              _c("wk-table-items", {
                attrs: {
                  "field-from": _vm.fieldForm,
                  "field-list": _vm.addFieldList,
                  "prop-prefix": _vm.propPrefix,
                  disabled: _vm.disabled,
                },
                on: { delete: _vm.deleteClick, change: _vm.formChange },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "add-btn" },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "text" }, on: { click: _vm.addClick } },
                    [
                      _c("i", { staticClass: "wk wk-l-plus" }),
                      _vm._v("\n        " + _vm._s(_vm.btnName) + "\n      "),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }